import { VoiceAgentFeaturesService } from '../../api/services/VoiceAgentFeaturesService';

/**
 * Visibility rules for the "Phone Message" (`VoiceMessage`) notification settings:
 * the company toggle in Internal Notifications and the row in a user's
 * notification preferences. The notifications themselves are never gated — they
 * only exist once a GPT-Live call took a message.
 */

/**
 * TEMPORARY GPT-Live rollout gate: true only when the current tenant has an
 * active GPT-Live test line. Remove this (and `gptLiveEnabled` below) once
 * GPT-Live is generally available.
 */
export function fetchGptLiveEnabled(): Promise<boolean> {
  return VoiceAgentFeaturesService.getApiAppVoiceAgentFeaturesGetGptLiveEnabled();
}

export interface VoiceMessageNotificationsGateInput {
  /** `useFeatureAccess('VoiceAgent').available` — the plan includes voice agents (Scale). */
  voiceAgentAvailable: boolean;
  /** `useFeatureAccess('VoiceAgent').loading` — hidden until the plan has loaded. */
  voiceAgentLoading: boolean;
  /** TEMPORARY GPT-Live rollout gate (false while loading or on error). */
  gptLiveEnabled: boolean;
}

/** Show the Phone Message settings only when the plan has voice agents AND GPT-Live is on. */
export function canShowVoiceMessageNotifications({
  voiceAgentAvailable,
  voiceAgentLoading,
  gptLiveEnabled,
}: VoiceMessageNotificationsGateInput): boolean {
  return voiceAgentAvailable && !voiceAgentLoading && gptLiveEnabled;
}
